import { render } from "./LendPositions.vue?vue&type=template&id=4ea9504a"
import script from "./LendPositions.vue?vue&type=script&lang=js"
export * from "./LendPositions.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/defi/LendPositions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ea9504a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ea9504a', __exports__)) {
    api.reload('4ea9504a', __exports__)
  }
  
  module.hot.accept("./LendPositions.vue?vue&type=template&id=4ea9504a", () => {
    api.rerender('4ea9504a', render)
  })

}


export default __exports__